// @generated
// This file is automatically generated by Kanel. Do not modify manually.

import { z } from 'zod';

/** Represents the enum public.algorithm */
enum Algorithm {
  exponential = 'exponential',
  logarithmic = 'logarithmic',
};

export default Algorithm;

/** Zod schema for algorithm */
export const algorithm = z.enum([
  'exponential',
  'logarithmic',
]);
